import { createContext } from 'react';

import type { ContextualCommentResource, ContextualCommentTarget } from '@/types';

export interface ContextualCommentTargetContextValue {
    baseTarget: ContextualCommentTarget;
    resource?: ContextualCommentResource;
    resetTarget: () => void;
    setTarget: (target: ContextualCommentTarget) => void;
    target: ContextualCommentTarget;
}

export const ContextualCommentTargetContext = createContext<ContextualCommentTargetContextValue | undefined>(undefined);
